"use client"

import { useAppSelector } from "@/hooks/redux"
import { Skeleton } from "antd"

const ProductSizeButtonSkeleton = () => {
  const sizesSelectionSetting = useAppSelector(state => state.store.store_setting.data.colors_selection)
  return (
    <Skeleton.Button
      style={{
        height: `calc(${sizesSelectionSetting.height / 10}rem + ${sizesSelectionSetting.border_width}px)`,
        width: `calc(${sizesSelectionSetting.width / 10}rem + ${sizesSelectionSetting.border_width}px)`
      }}
      shape='circle'
      active
      size='large'
    />
  )
}

export default ProductSizeButtonSkeleton